import * as Rx from 'rxjs/Rx'
import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { Login } from '../../actions'

// Load credentials from storage
export const saveCredentials = (
  action$: ActionsObservable<Action>,
  _store: Store<State>,
  { credentialsStorage }: Dependencies
) =>
  action$.filter(Login.saveCredentials.started.match).switchMap(({ payload }) =>
    Rx.Observable.of(credentialsStorage.updateCredentials(payload)).map(() =>
      Login.saveCredentials.done({
        params: payload,
        result: undefined
      })
    )
  )

export default combineEpics<Epic>(saveCredentials)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/operations/saveCredentials.ts